import * as occlTemplates from './occl';
// eslint-disable-next-line import/no-cycle
import * as tefOneTemplates from './tefOne';

export type TemplatesType = typeof tefOneTemplates;

export const templates = {
  occl: occlTemplates as unknown as TemplatesType,
  tefOne: tefOneTemplates,
};
